/* eslint-disable */
// 定义项目内的表名
const featuresFeaturesItemList = "features/item-list"; // 功能模板1表名
const featuresFeaturesItemListAll = "singleTableTabPage/item-list-all"; // 功能模板2所有表名
const featuresFeaturesItemListOpened = "singleTableTabPage/item-list-opened"; // 功能模板2已启用表名
const featuresFeaturesItemListClosed = "singleTableTabPage/item-list-closed"; // 功能模板2已禁用表名
const listqueryList = "listQuery/item-list"; // 增删改查表名
const peoplemanageItemListAll = "peoplemanage/item-list-all"; // 人员信息全部表名
const peoplemanageItemListOnjob = "peoplemanage/item-list-onthejob"; // 人员信息在职在岗表名
const peoplemanageItemListleavejob = "peoplemanage/item-list-leavejob"; // 人员信息在职离岗表名
const peoplemanageItemListOnbutleave = "peoplemanage/item-list-onjobbutleave"; // 人员信息离职离岗表名
const featuresTemplateNavTable1 = "features-template/nav-table1"; // 应用导航表名
const inquiryCollect = "inquiry/inquiry-collect"; // 询价定投统计表
const peoplemanageSingleTab = "list-query/peoplemanageSingleTab"; // 主子表增删改查
const contractmaterialsList = "example-auto/demouser"; // 代码生成单表
const demouserList = "example-auto/demouserList"; // 代码生成单表主子表

/** 供应商门户 start **/
const viewMoreList = "shop/viewMore"; // 采购公告查询全部
/** 供应商门户 end **/

const tableList = {
  featuresFeaturesItemList,
  featuresFeaturesItemListAll,
  featuresFeaturesItemListOpened,
  featuresFeaturesItemListClosed,
  listqueryList,
  demouserList,
  peoplemanageItemListAll,
  peoplemanageItemListOnjob,
  peoplemanageItemListleavejob,
  peoplemanageItemListOnbutleave,
  featuresTemplateNavTable1,
  inquiryCollect,
  contractmaterialsList,
  peoplemanageSingleTab,
  viewMoreList
};
export default tableList;
